export enum Status {
  Open = 'O',
  Closed = 'C',
}

export default class StatusTransform {
  deserialize(serialized: string): Status {
    switch (serialized) {
      case 'O':
        return Status.Open;
      case 'C':
        return Status.Closed;
    }
    throw new Error('Status not recognized');
  }

  serialize(deserialized: Status) {
    return deserialized.toString();
  }
}
